<template>
  <div
    v-if="coverInfo !== null"
    class="row policy-cover-row"
    data-test-policy-coverages-cover-type="cover"
    data-test-policy-coverages-cover
  >
    <LabelAndTooltip class="columns" :label="coverInfo.name" :tooltip="coverInfo.tooltip" />
    <div class="columns" data-test-policy-coverages-cover-value v-html="coverInfo.value" />
  </div>
</template>

<script>
import LabelAndTooltip from '@/components/UI/LabelAndTooltip.vue';

export default {
  components: {
    LabelAndTooltip
  },
  props: {
    coverInfo: {
      type: Object,
      default() {
        return null;
      }
    }
  }
};
</script>
